import React from "react";
import Cookies from 'js-cookie';

const Returnedpayments = ({ columns, rows, nodatatext, eftcontent }) => {
    return (
        <>
            <table tabIndex={0} className="table table-striped" style={{ marginLeft: '' }}>
                <thead className="sticky-top">
                    <tr>
                        {
                            columns && columns?.map((item) => <th scope="col">{item}</th>)
                        }
                    </tr>
                </thead>
                <tbody>
                    { rows?.length === 0 ? (
                         <td colSpan={7} className="fw-semibold">
                            <div className="d-flex px-2">
                    <div className="col-12 mb-2">
                      <h6 className="paymenthistorymodal">{nodatatext}</h6>
                    </div>
                  </div>
                         </td>
                    ) : (
                    rows && rows?.map((item, index) => <tr key={index} className="border-bottom">
                        <td>{item.return_date}</td>
                        <td>{(item.return_type === 'EFT via Web' && Cookies.get('owningCarrier') === 'Q5') ? eftcontent : item.return_type}</td>
                        <td>{item.return_name}</td>
                        <td>{item.return_code}</td>
                        <td>{item.return_description}</td>
                        <td>{item.last4}</td>
                        <td>{item.return_amount}</td>                        
                    </tr>))}
                </tbody>
            </table>
        </>
    )
}

export default Returnedpayments;